export enum IcpIntelInferenceStatusEnum {
  CREATED = 'CREATED',
  MODEL = 'MODEL',
  MODEL_ERROR = 'MODEL_ERROR',
  MODEL_TIMEOUT = 'MODEL_TIMEOUT',
  MODEL_COMPLETED = 'MODEL_COMPLETED',
  INFERENCE = 'INFERENCE',
  INFERENCE_ERROR = 'INFERENCE_ERROR',
  INFERENCE_COMPLETED = 'INFERENCE_COMPLETED',
  STOPPED = 'STOPPED'
}

const ERROR_STATUS_LIST: IcpIntelInferenceStatusEnum[] = [
  IcpIntelInferenceStatusEnum.MODEL_ERROR,
  IcpIntelInferenceStatusEnum.INFERENCE_ERROR,
];

const COMPLETED_STATUS_LIST: IcpIntelInferenceStatusEnum[] = [
  ...ERROR_STATUS_LIST,
  IcpIntelInferenceStatusEnum.MODEL_TIMEOUT,
  IcpIntelInferenceStatusEnum.STOPPED,
  IcpIntelInferenceStatusEnum.INFERENCE_COMPLETED,
];

export namespace IcpIntelInferenceStatusEnum {
  export function getErrorStatusList(): IcpIntelInferenceStatusEnum[] {
    return ERROR_STATUS_LIST;
  }

  export function getCompletedStatusList(): IcpIntelInferenceStatusEnum[] {
    return COMPLETED_STATUS_LIST;
  }
}
